module.exports = __webpack_public_path__ + "img/hzb.764f4d7.png";